import { BecomeACustomerModel } from "@GeriMed/Type/ApiModelsExt";
import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const accountsUrl = "/api/v2/becomeacustomer";

export interface BecomeACustomerParameterExt {
    account: BecomeACustomerModel;
}

export async function becomeACustomer(parameter: BecomeACustomerParameterExt): Promise<ServiceResult<BecomeACustomerModel>> {
    try {
        const accountModel = await post<BecomeACustomerModel>(`${accountsUrl}`, parameter.account as BecomeACustomerModel);
      return {
            result: accountModel,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        return {
            successful: false,
            errorMessage: "Invalid request, please try again later.",
        };
    }
}